// 人事管理
export default [
  {
    path: '/staff',
    meta: { title: '员工管理' },
    component: () => import('../views/staff/index'),
    children: [
      {
        path: '/staff/list',
        name: 'list',
        meta: { title: '员工列表', isMenu: true },
        component: () => import('../views/staff/list.vue'),
      },
      {
        path: '/staff/department',
        name: 'department',
        meta: { title: '部门管理', isMenu: true },
        component: () => import('../views/staff/department.vue'),
      },
      {
        path: '/staff/position',
        name: 'position',
        meta: { title: '职位管理', isMenu: true },
        component: () => import('../views/staff/position.vue'),
      },
      
    ],
  },
];
